export default function scrollToFirstError(formik) {
  if (!formik.isSubmitting) return;
  if (Object.keys(formik.errors).length > 0) {
    const elem = document.getElementsByName(Object.keys(formik.errors)[0])[0];
    elem.scrollIntoView({ behavior: "smooth", block: "center" });
    elem.focus();
  }
}
